<div class="dashboard-tile">
  <div class="tile-header">
    <div class="tile-header-title">Top Risk Areas</div>
  </div>
  <mat-list class="tile-content flush">
    <mat-list-item *ngFor="let nistSubCategory of getImportantSubCategories()" class="bg-accent-hover selectable" [ngClass]="{'bg-accent-selected':nistSubCategory == selectedNistSubCategory}"  (click)="setSelectedNistSubCategory(nistSubCategory)">
      <span style="padding-right:20px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" matTooltip="{{nistSubCategory.text}}">{{ nistSubCategory.id }}: {{ nistSubCategory.text }}</span>
      <mat-chip-list style="margin-left: auto;">
        <mat-chip [ngStyle]="{'background-color': getRiskColor(nistSubCategory.scoreData)}" (click)="setSelectedNistSubCategory(nistSubCategory)">{{ getRiskLabel(nistSubCategory.scoreData) }}</mat-chip>
      </mat-chip-list>
      <mat-divider></mat-divider>
    </mat-list-item>
  </mat-list>
</div>
  